export default __webpack_public_path__ + "static/media/FOG_Hero.a26dd612.mp4";